import { Component, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
  DatepickerMode,
  SuiModalService,
} from '@richardlt/ng2-semantic-ui';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from '@angular/forms';
import { AppFilter, User } from '@app/shared/models';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WorkFlowService } from '../../services/workflow.service';
import { ConfirmModal } from '@app/shared/modals';
interface Unit {
  organizationUnitId: string;
  organizationId: string;
  unitName: string;
  actionAdditionalDetails: string;
  dateCreated: string;
  dateModified: string;
  createdBy: string;
  modifiedBy: string;
}
interface IAssignUsersContext {
  title?: string;
  extraData: any;
  documentTypes: any;
}

@Component({
  selector: 'app-assign-document-type-modal',
  templateUrl: './assign-document-type-modal.component.html',
  styleUrls: ['./assign-document-type-modal.component.scss'],
})
export class AssignDocumentTypeModalComponent implements OnInit {
  filter: AppFilter;
  success: any;
  error: any;
  pending: boolean = false;
  workflow: any;
  allUsers: any;
  allDocuments: any;
  formSubmitAttempt;
  groupUser: Array<string> = [];
  selectedUsers = [];
  unselectedUsers = [];
  selectedDocuments = [];
  unselectedDocuments = [];
  searchable = true;
  groupId;
  search = new FormControl('');
  extraData;

  searchFilter = {
    groupOp: 'AND',
    rules: [
      {
        field: 'organizationId.organizationTypeId.organizationTypeId',
        op: 'ne',
        data: 'contractor',
      },
    ],
  };
  organizationId =
    localStorage.getItem('user') != null
      ? JSON.parse(localStorage.getItem('user'))['organizationId'][
          'organizationId'
        ]
      : '';

  constructor(
    public modal: SuiModal<IAssignUsersContext, String, void>,
    private workflowService: WorkFlowService,
    private fb: FormBuilder,
    private modalService: SuiModalService
  ) {
    this.selectedDocuments = this.modal.context.documentTypes;
    this.getDocumentType('');
    this.extraData = modal.context.extraData;
    console.log(this.selectedDocuments, this.extraData);
    this.search.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((searchText) => {
        this.searchUser(searchText);
      });
    this.unitFilter = new AppFilter({
      _search: true,
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
  }
  getDocumentType(data) {
    this.pending = true;
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
    if (data !== '') {
      this.filter.filters = JSON.stringify(data);
    }
    this.workflowService
      .getDocumentType({
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.allDocuments = res['rows'] as Array<User>;
          this.allDocuments = this.allDocuments.filter((item) => item.isActive);
          this.unselectedDocuments = this.allDocuments.filter(
            (elem) =>
              !this.selectedDocuments.find(
                (documentTypeId) =>
                  elem.documentTypeId === documentTypeId.documentTypeId
              )
          );
          // this.selectedDocuments = this.allDocuments.filter((elem) =>
          //   this.selectedDocuments.find(
          //     (documentTypeId) => elem.documentTypeId === documentTypeId
          //   )
          // );

          console.log('selecteddocumentTypeId ', this.selectedDocuments);

          // this.selectedDocuments.forEach((u) => {
          //   if (u['firstName'] === null) {
          //     u['firstName'] = u['appUserEmail'];
          //   }
          //   if (u['lastName'] === null) {
          //     u['lastName'] = '';
          //   }
          //   u.name = `${u['firstName']} ${u['lastName']}`;
          // });
          // this.unselectedDocuments.forEach((u) => {
          //   if (u['firstName'] === null) {
          //     u['firstName'] = u['appUserEmail'];
          //   }
          //   if (u['lastName'] === null) {
          //     u['lastName'] = '';
          //   }
          //   u.name = `${u['firstName']} ${u['lastName']}`;
          // });

          console.log(this.selectedDocuments, 'users');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }
  getUsers(search) {
    this.pending = true;
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
    if (search !== '') {
      this.filter.filters = JSON.stringify(search);
    }
    this.workflowService
      .getAllAppUsers({
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.pending = false;
          this.allUsers = res['rows'] as Array<User>;

          this.unselectedUsers = this.allUsers.filter(
            (elem) =>
              !this.selectedUsers.find(
                (appUserId) => elem.appUserId === appUserId
              )
          );
          this.selectedUsers = this.allUsers.filter((elem) =>
            this.selectedUsers.find((appUserId) => elem.appUserId === appUserId)
          );

          console.log('selectedUsers ', this.selectedUsers);

          this.selectedUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });
          this.unselectedUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });

          console.log(this.selectedUsers, 'users');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  getOrganizationUsers() {
    this.pending = true;
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 1000,
      sord: 'desc',
    });
    this.filter.filters = JSON.stringify(this.searchFilter);
    this.workflowService
      .getAllAppUsersInOrganization({
        organizationId: this.organizationId,
        params: this.filter,
      })
      .subscribe(
        (res) => {
          this.allUsers = res['rows'] as Array<User>;
          this.unselectedUsers = this.allUsers.filter(
            (elem) =>
              !this.selectedUsers.find(
                (appUserId) => elem.appUserId === appUserId
              )
          );
          this.selectedUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });
          this.unselectedUsers.forEach((u) => {
            if (u['firstName'] === null) {
              u['firstName'] = u['appUserEmail'];
            }
            if (u['lastName'] === null) {
              u['lastName'] = '';
            }
            u.name = `${u['firstName']} ${u['lastName']}`;
          });
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  searchUser(search) {
    this.selectedUsers = this.modal.context.documentTypes;
    if (search === '') {
      this.filter = new AppFilter({ sidx: 'dateCreated' });
      this.getUsers('');
    } else {
      let searchFilter = {
        groupOp: 'OR',
        rules: [
          {
            field: 'appUserEmail',
            op: 'cn',
            data: '',
          },
          {
            field: 'lastName',
            op: 'cn',
            data: '',
          },
          {
            field: 'firstName',
            op: 'cn',
            data: '',
          },
        ],
      };
      searchFilter.rules[0].data = search;
      searchFilter.rules[1].data = search;
      searchFilter.rules[2].data = search;
      this.filter.filters = JSON.stringify(searchFilter);
    }
  }

  checkChange(id, event) {
    if (event.target.checked) {
      this.selectedDocuments.push(id);
    } else {
      this.selectedDocuments.forEach((u) => {
        if (u == id) {
          this.selectedDocuments.splice(this.selectedDocuments.indexOf(id), 1);
        }
      });
    }
  }

  isChecked(id) {
    if (this.selectedDocuments.filter((i) => i == id).length > 0) {
      return true;
    } else {
      return false;
    }
  }

  close() {
    this.success = null;
    this.error = null;
  }

  ngOnInit(): void {
    this.getOrganizations();
  }

  unitFilter: AppFilter;
  selectedUnit;
  units;
  selectedUnitId;
  getOrganizations() {
    this.workflowService
      .getAllOrganizationUnits({
        organizationId: this.organizationId,
        params: this.unitFilter,
      })
      .subscribe(
        (e) => {
          this.units = e.rows as Array<Unit>;
          if (this.units.length > 0) {
            this.selectedUnit = this.units[0];
            this.selectedUnitId = this.units[0]['organizationId'];
          }
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }
  replaceSpacesWithUnderscores(inputString) {
    return inputString.replace(/\s+/g, '_');
  }
  save() {
    this.pending = true;
    let data = [];
    this.selectedDocuments.map((item) => {
      if (item.documentTypeId) {
      } else {
        data.push(item);
      }
    });
    this.workflowService
      .assignDocumentType({
        optionId: this.extraData,
        body: {
          ids: data,
        },
      })
      .subscribe(
        (e) => {
          this.modal.approve('Document Type Assigned successfully');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  onDelete(event) {
    this.modalService
      .open(
        new ConfirmModal(
          'Remove Document Type?',
          'Are you sure you want to document type?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.unAssign(event);
      })
      .onDeny(() => {
        // event.selected = true;
      });
  }

  onAssign() {
    this.modalService
      .open(
        new ConfirmModal(
          'Assign Documents?',
          'Are you sure you want to assign Documents?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.save();
      })
      .onDeny(() => {
        // event.selected = true;
      });

    // let users = this.unselectedUsers.filter((user) => user.selected == true);
    // console.log(users);
    // if (users.length === 0) {
    //   this.modal.approve(null);
    // } else {
    //   this.modalService
    //     .open(
    //       new ConfirmModal(
    //         'Assign User?',
    //         'Are you sure you want to assign user?',
    //         ModalSize.Tiny
    //       )
    //     )
    //     .onApprove(() => {
    //       this.save();
    //     })
    //     .onDeny(() => {
    //       // event.selected = true;
    //     });
    // }
  }

  unAssign(data) {
    this.pending = true;
    this.workflowService
      .unAssignDocumentType({
        documentTypeIds: data,
        optionId: this.replaceSpacesWithUnderscores(this.extraData),
      })
      .subscribe(
        (e) => {
          this.modal.approve('Document type unassigned successfully');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage ? error.error.errorMessage
                                                : error.error ? error.error
                                                : error;
        }
      );
  }

  removeItemAll(arr, value) {
    var i = 0;
    while (i < arr.length) {
      if (arr[i] === value) {
        arr.splice(i, 1);
      } else {
        ++i;
      }
    }
    return arr;
  }
}

export class AssignDocumentTypeModal extends ComponentModalConfig<
  IAssignUsersContext,
  void,
  void
> {
  constructor(
    title,
    extraData: any,
    documentTypes: any,
    size: ModalSize = ModalSize.Tiny
  ) {
    super(AssignDocumentTypeModalComponent, {
      title,
      extraData,
      documentTypes,
    });

    this.transition = 'slide left';
    this.isClosable = false;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
